import { JOTAMetadataType } from '@App/libs/interfaces'

export const JOTAMetadata: JOTAMetadataType = {
    name: 'JOTA Jornalismo',
    shortname: 'JOTA',
    sitename: 'JOTA Info',
    language: 'pt-BR',
    url: process.env.NEXT_PUBLIC_JOTAINFO_FRONT,
    urlLogo: new URL(
        'https://images.jota.info/wp-content/uploads/2025/05/jota-thumb-imageog.png'
    ).href,
    urlLogoPro: new URL(
        'https://images.jota.info/wp-content/uploads/2025/05/jota-pro-thumb-imageog.png'
    ).href,
    alternativeURL: [
        'https://www.facebook.com/jotajustica/',
        'https://www.instagram.com/jotaflash/',
        'https://www.linkedin.com/company/jotainfo',
        'https://www.youtube.com/jotalive',
        'https://twitter.com/jotainfo'
    ]
}
